/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  /*document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });*/

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

  // Accessibility: Move focus to submenu trigger when 'Go back' is activated
  // This enables keyboard/screen reader users to return to the correct menu item

  document.addEventListener('click', function(e) {
    let btn = e.target.closest('.drawer__button[data-focus-trigger]');
    if (btn) {
      let triggerKey = btn.getAttribute('data-focus-trigger');
      setTimeout(function() {
        let trigger = document.querySelector('[data-submenu-trigger="' + triggerKey + '"]');
        if (trigger) {
          trigger.focus();
        }
      }, 100);
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
  document.addEventListener('DOMContentLoaded', () => {
    const dropdowns = document.querySelectorAll('.announcement-text__select');
    if (!dropdowns.length) return;

    dropdowns.forEach(dropdown => {
      const selected = dropdown.querySelector('.announcement-text__select__selected');
      const label = dropdown.querySelector('.announcement-text__select__label');
      const options = dropdown.querySelectorAll('.announcement-text__select__option');

      if (selected) {
        selected.addEventListener('click', () => {
          dropdown.classList.toggle('open');
        });
      }

      if (options.length > 0) {
        options.forEach(option => {
          option.addEventListener('click', () => {
            // if (label) {
            //   label.textContent = option.textContent;
            //   label.dataset.value = option.dataset.value;
            // }
            dropdown.classList.remove('open');
          });
        });
      }
    });
    
    // Capitalize all h1 and h2 tags on pages with .default-page body class
    if (document.body.classList.contains('default-page')) {
      const headingElements = document.querySelectorAll('h1, h2, h3');
      headingElements.forEach(heading => {
        // Get the text content and convert to proper case
        const text = heading.textContent || heading.innerText;
        if (text) {
          // Convert to lowercase first, then capitalize each word
          // Use Unicode-aware regex that handles German umlauts and other international characters
          const capitalizedText = text.toLowerCase().replace(/(^|\s)(\p{L})/gu, (match, space, letter) => space + letter.toUpperCase());
          heading.textContent = capitalizedText;
        }
      });
    }

    function fillInput(selector, value) {
      const input = document.getElementById(selector);
      if (input) {
        input.value = value;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // MAIN Newsletter
    let mainklaviyoPushed = false;
    const mainForm = document.getElementById('footer-newsletter');
    
    if (!mainForm) {
      return;
    }
    
    const isCanadianShop = window.location.hostname.includes('canada') || window.location.hostname.includes('ca');
    const mainKlaviyoEmailId = isCanadianShop ? 'email_01KGPX6Q4HZ80ZRTZCW7T0WD7P' : 'email_01K6FM1E46TH2D0H3MPDACNQ7Z';
    const mainKlaviyoFormClass = isCanadianShop ? '.klaviyo-form-W9BWZT' : '.klaviyo-form-WqR6Hn';
    
    let allowMainSubmit = false;
    const originalMainSubmit = mainForm.submit.bind(mainForm);
    
    // Override form submit method
    mainForm.submit = function () {
      if (allowMainSubmit) {
        originalMainSubmit();
      }
    };

    // Override submit button click handler
    const mainSubmitButton = mainForm.querySelector('button[type="submit"]');
    if (mainSubmitButton) {
      // Remove any existing event listeners by cloning the button
      const newSubmitButton = mainSubmitButton.cloneNode(true);
      mainSubmitButton.parentNode.replaceChild(newSubmitButton, mainSubmitButton);
      
      newSubmitButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Check privacy policy checkbox
        const privacyCheckbox = mainForm.querySelector('.privacy-policy-checkbox input[type="checkbox"]');
        const privacyError = mainForm.querySelector('[id*="privacy-policy-error"]');
        
        if (privacyCheckbox && !privacyCheckbox.checked) {
          if (privacyError) {
            privacyError.classList.remove('hidden');
          }
          return; // Don't submit if privacy policy not checked
        } else if (privacyError) {
          privacyError.classList.add('hidden');
        }
        
        if (!mainklaviyoPushed) {
          mainklaviyoPushed = true;
          const userMainEmail = document.getElementById('mail-footer-newsletter').value.trim();

          function waitForMainKlaviyoInputs(callback) {
            const interval = setInterval(() => {
              const emailInput = document.getElementById(mainKlaviyoEmailId);

              if (emailInput) {
                clearInterval(interval);
                callback();
              }
            }, 200);
          }

          waitForMainKlaviyoInputs(() => {
            fillInput(mainKlaviyoEmailId, userMainEmail);

            setTimeout(() => {
              const submitButton = document.querySelector(mainKlaviyoFormClass + ' .needsclick.go300628013');
              if (submitButton) {
                submitButton.click();
              }
            }, 500);
          });
          
          setTimeout(() => {
            allowMainSubmit = true;
            setTimeout(() => {
              mainForm.submit();
            }, 100);
          }, 1000);
        } else {
          allowMainSubmit = true;
          mainForm.submit();
        }
      });
    }

    // PETS Newsletter
    let petklaviyoPushed = false;
    const petForm = document.getElementById('pets-footer-newsletter');
    
    if (!petForm) {
      return;
    }
    
    const petKlaviyoEmailId = isCanadianShop ? 'email_01KGPX1RKG76PZQ9DFQ1SQDTEP' : 'email_01K6GJADSPMX7S4ECYCXY3AJ63';
    const petKlaviyoFormClass = isCanadianShop ? '.klaviyo-form-XBaP7T' : '.klaviyo-form-Ytr2tP';
    const petKlaviyoButtonClass = isCanadianShop ? '.needsclick.go300628013' : '.needsclick.go3265039304';
    
    let allowSubmit = false;
    const originalSubmit = petForm.submit.bind(petForm);
    
    // Override form submit method
    petForm.submit = function () {
      if (allowSubmit) {
        originalSubmit();
      }
    };

    // Override submit button click handler
    const petSubmitButton = petForm.querySelector('button[type="submit"]');
    if (petSubmitButton) {
      // Remove any existing event listeners by cloning the button
      const newPetSubmitButton = petSubmitButton.cloneNode(true);
      petSubmitButton.parentNode.replaceChild(newPetSubmitButton, petSubmitButton);
      
      newPetSubmitButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Check privacy policy checkbox
        const privacyCheckbox = petForm.querySelector('.privacy-policy-checkbox input[type="checkbox"]');
        const privacyError = petForm.querySelector('[id*="privacy-policy-error"]');
        
        if (privacyCheckbox && !privacyCheckbox.checked) {
          if (privacyError) {
            privacyError.classList.remove('hidden');
          }
          return; // Don't submit if privacy policy not checked
        } else if (privacyError) {
          privacyError.classList.add('hidden');
        }
        
        if (!petklaviyoPushed) {
          petklaviyoPushed = true;
          const userEmail = document.getElementById('mail-pets-footer-newsletter').value.trim();

          function waitForKlaviyoInputs(callback) {
            const interval = setInterval(() => {
              const emailInput = document.getElementById(petKlaviyoEmailId);

              if (emailInput) {
                clearInterval(interval);
                callback();
              }
            }, 200);
          }

          waitForKlaviyoInputs(() => {
            fillInput(petKlaviyoEmailId, userEmail);

            setTimeout(() => {
              const submitButton = document.querySelector(petKlaviyoFormClass + ' ' + petKlaviyoButtonClass);
              if (submitButton) {
                submitButton.click();
              }
            }, 500);
          });
          
          setTimeout(() => {
            allowSubmit = true;
            setTimeout(() => {
              petForm.submit();
            }, 100);
          }, 1000);
        } else {
          allowSubmit = true;
          petForm.submit();
        }
      });
    }
  });
})();

(function () {
  const widgetSelector = '#sca-fg-today-offer-widget';

  function unitFromLabel(text) {
    const value = (text || '').replace(/\s+/g, ' ').trim().toLowerCase();
    if (/^days?$/.test(value)) return 'days';
    if (/^(hours?|hrs?)$/.test(value)) return 'hours';
    if (/^(minutes?|mins?)$/.test(value)) return 'minutes';
    if (/^(seconds?|secs?)$/.test(value)) return 'seconds';
    return '';
  }

  function labelNumbers(scope) {
    scope.querySelectorAll('span, strong, b, div, p').forEach((node) => {
      if (node.querySelector('[data-gift-timer-unit]')) return;
      const text = node.childElementCount === 0
        ? node.textContent.trim()
        : Array.from(node.childNodes).filter((child) => child.nodeType === 3).map((child) => child.textContent).join('').trim();
      if (!/^\d{1,3}$/.test(text)) return;
      const parent = node.parentElement;
      if (!parent) return;
      let unit = '';
      Array.from(parent.children).forEach((sibling) => {
        if (unit || sibling === node) return;
        unit = unitFromLabel(sibling.textContent);
      });
      if (!unit) return;
      const hidden = document.createElement('span');
      hidden.className = 'visually-hidden';
      hidden.setAttribute('data-gift-timer-unit', unit);
      hidden.textContent = unit + ' ';
      node.prepend(hidden);
    });
  }

  function labelWidget(host) {
    if (!host || host.nodeType !== 1) return;
    if (!host.getAttribute('role')) host.setAttribute('role', 'region');
    if (!host.getAttribute('aria-label') && !host.getAttribute('aria-labelledby')) {
      host.setAttribute('aria-label', 'Limited gift offer');
    }
    if (host.shadowRoot) {
      labelNumbers(host.shadowRoot);
      return;
    }
    labelNumbers(host);
  }

  function watchHost(host) {
    if (host.dataset.giftTimerWatching === 'true') return;
    host.dataset.giftTimerWatching = 'true';
    const scope = host.shadowRoot || host;
    new MutationObserver(() => labelWidget(host)).observe(scope, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function scan() {
    document.querySelectorAll(widgetSelector).forEach((host) => {
      labelWidget(host);
      watchHost(host);
    });
  }

  new MutationObserver((mutations) => {
    const hit = mutations.some((mutation) => {
      const el = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
      if (el && el.closest && el.closest(widgetSelector)) return true;
      return Array.from(mutation.addedNodes).some((node) => {
        return node.nodeType === 1 && (node.matches?.(widgetSelector) || node.querySelector?.(widgetSelector));
      });
    });
    if (hit) scan();
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
})();
